"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var TextFieldProps_1 = require("./TextFieldProps");
var textfieldStyles = require("./TextField.css");
require("./TextField.desktop.css");
require("./TextField.mobile.css");
require("./TextField.tablet.css");
var icons = require("./../../../styles/att-icons.css");
var TextField = /** @class */ (function (_super) {
    __extends(TextField, _super);
    function TextField(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            currentTextValue: _this.props.data.input ? _this.props.data.input : '',
            disabled: props.options.disabled || false,
            enableEye: _this.props.options.hasEye,
            maskedValue: _this.props.data.input ? _this.mask(_this.props.data.input) : '',
        };
        _this.onChange = _this.onChange.bind(_this);
        _this.onKeyPress = _this.onKeyPress.bind(_this);
        _this.onKeyUp = _this.onKeyUp.bind(_this);
        _this.onBlur = _this.onBlur.bind(_this);
        _this.onFocus = _this.onFocus.bind(_this);
        _this.onClear = _this.onClear.bind(_this);
        _this.onShowPassword = _this.onShowPassword.bind(_this);
        _this.referenceState = _this.referenceState.bind(_this);
        _this.getContainerClass = _this.getContainerClass.bind(_this);
        return _this;
    }
    TextField.prototype.componentWillReceiveProps = function (newProps) {
        if (newProps.data.input !== this.state.currentTextValue) {
            if (this.props.options.type === TextFieldProps_1.TextFieldType.NUMERIC_PASSWORD) {
                this.setState({
                    currentTextValue: newProps.data.input,
                    maskedValue: this.mask(newProps.data.input),
                });
            }
            else {
                this.setState({
                    currentTextValue: newProps.data.input,
                });
            }
        }
        if (newProps.options.disabled !== this.state.disabled) {
            this.setState({ disabled: newProps.options.disabled });
        }
    };
    TextField.prototype.onChange = function (event) {
        var value = this.evaluateValue(event);
        this.setState({
            currentTextValue: value,
            maskedValue: this.mask(event.currentTarget.value),
        });
        if (this.props.options.type === TextFieldProps_1.TextFieldType.NUMERIC_PASSWORD ||
            this.props.options.type === TextFieldProps_1.TextFieldType.PASSWORD) {
            event.currentTarget.value = value;
        }
        if (this.props.events && this.props.events.onChange) {
            this.props.events.onChange(event);
        }
    };
    TextField.prototype.onKeyPress = function (event) {
        if (this.props.options.type === TextFieldProps_1.TextFieldType.NUMERIC_PASSWORD
            && (event.charCode <= 47 || event.charCode >= 58)) {
            event.preventDefault();
        }
        else if (this.props.events && this.props.events.onKeyPress) {
            this.props.events.onKeyPress(this.state.currentTextValue, event);
        }
    };
    TextField.prototype.onKeyUp = function (event) {
        if (this.props.events && this.props.events.onKeyUp) {
            this.props.events.onKeyUp(this.state.currentTextValue, event);
        }
    };
    TextField.prototype.onBlur = function (event) {
        if (this.props.events && this.props.events.onBlur) {
            this.props.events.onBlur(this.state.currentTextValue);
        }
    };
    TextField.prototype.onFocus = function (event) {
        if (this.props.events && this.props.events.onFocus) {
            this.props.events.onFocus(this.state.currentTextValue, event);
        }
    };
    TextField.prototype.onClear = function (event) {
        var _this = this;
        this.setState({ currentTextValue: '' }, function () {
            if (_this.props.events && _this.props.events.onClear) {
                _this.props.events.onClear(_this.state.currentTextValue, event);
            }
        });
        // hack for triggering the blur event again after clearing the value fixes tdp defect #674372
        if (this.inputEl) {
            this.inputEl.blur();
            this.inputEl.focus();
        }
        // this.inputEl.focus();
    };
    TextField.prototype.onShowPassword = function (event) {
        this.setState({ enableEye: !this.state.enableEye });
    };
    TextField.prototype.getContainerClass = function () {
        return this.props.options.withTooltip ? [textfieldStyles.textFieldContainer, textfieldStyles.withTooltip,
            this.props.options.type === TextFieldProps_1.TextFieldType.PASSWORD &&
                this.props.options.hasEye ? textfieldStyles.eyeAvailable : ''].join(' ')
            : textfieldStyles.textFieldContainer;
    };
    TextField.prototype.render = function () {
        var _this = this;
        var currentTextValue = this.state.currentTextValue;
        var isRedesign = this.props.options && this.props.options.isRedesign;
        var isRennyStyle = this.props.options && this.props.options.isRennyStyle;
        return (React.createElement("div", { "data-test-id": this.props.testId, className: this.getContainerClass() },
            React.createElement("input", { autoComplete: this.props.spi ? 'none' : this.props.options.autocompleteOption, autoCapitalize: this.props.options.autoCapitalizeOption, className: [isRennyStyle ? textfieldStyles.textFieldRenny :
                        isRedesign ? textfieldStyles.textFieldRedesign : textfieldStyles.textField,
                    this.props.options.className].join(' '), value: this.referenceState(), onChange: this.onChange, onKeyPress: this.onKeyPress, onKeyUp: this.onKeyUp, onBlur: this.onBlur, onFocus: this.onFocus, disabled: this.state.disabled, type: this.decideInputType(), placeholder: this.props.data.placeHolder, name: this.props.data.name, maxLength: this.props.options.maxLength, "data-spi": this.props.spi, "aria-label": this.props.options.type === TextFieldProps_1.TextFieldType.PASSWORD ? this.props.options.type :
                    this.props.options.type + ' ' + this.props.options.accessibility, ref: function (el) { return _this.inputEl = el; } }),
            (this.props.options.type !== TextFieldProps_1.TextFieldType.PASSWORD) && currentTextValue && !isRedesign &&
                React.createElement("button", { "aria-label": this.props.options.clearButtonAccessibility || 'Clear ' + this.props.options.type, className: [textfieldStyles.clearIcon, textfieldStyles.hideOnDesktopView,
                        icons.attIcon, icons.attIconClose].join(' '), onClick: this.onClear })));
    };
    TextField.prototype.referenceState = function () {
        return this.props.options.type === TextFieldProps_1.TextFieldType.NUMERIC_PASSWORD
            ? this.state.maskedValue : this.state.currentTextValue;
    };
    TextField.prototype.evaluateValue = function (event) {
        var evaluatedResult = event.currentTarget.value;
        var stateValue = this.state.currentTextValue ? this.state.currentTextValue : '';
        if (this.props.options.type === TextFieldProps_1.TextFieldType.NUMERIC_PASSWORD) {
            var value = event.currentTarget.value;
            // delete key handling
            if (value.length < stateValue.length) {
                evaluatedResult = stateValue.substring(0, stateValue.length - 1);
            }
            else {
                evaluatedResult = stateValue + value.substring(value.length - 1);
            }
        }
        return evaluatedResult;
    };
    TextField.prototype.decideInputType = function () {
        var inputType = this.props.options.type;
        switch (this.props.options.type) {
            case TextFieldProps_1.TextFieldType.NUMERIC_PASSWORD:
                inputType = TextFieldProps_1.TextFieldType.TEL;
                break;
            case TextFieldProps_1.TextFieldType.PASSWORD:
                if (this.props.options.hasEye && !this.state.enableEye) {
                    inputType = TextFieldProps_1.TextFieldType.TEXT;
                }
                break;
        }
        return inputType;
    };
    Object.defineProperty(TextField.prototype, "ariaLabelContent", {
        get: function () {
            return (this.props.options.accessibility || '') + ", " + this.props.options.type;
        },
        enumerable: false,
        configurable: true
    });
    TextField.prototype.mask = function (value) {
        var maskedValue = '';
        if (value && value !== '') {
            maskedValue = value.replace(/[0-9]/g, TextFieldProps_1.MASK_CHARACTER.DEFAULT);
        }
        return maskedValue;
    };
    TextField.defaultProps = {
        options: {
            autocompleteOption: 'on',
            className: '',
            type: TextFieldProps_1.TextFieldType.TEXT,
        },
        spi: false,
    };
    return TextField;
}(React.Component));
exports.default = TextField;
//# sourceMappingURL=TextField.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/ui-components/components/atoms/TextField/TextField.js
// module id = 480
// module chunks = 8